import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

const PassengerCounter = ({ label, subtitle, value, setValue, min = 0, max = 9 }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" sx={{ 
        fontWeight: 500, 
        fontSize: '15px', 
        color: '#333',
        fontFamily: 'inherit',
        whiteSpace: 'nowrap'
      }}>
        {label}
      </Typography>
      {subtitle && (
        <Typography variant="caption" sx={{ 
          color: '#666', 
          fontSize: '13px',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap'
        }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <IconButton
        size="small"
        onClick={() => setValue(Math.max(min, value - 1))}
        disabled={value === min}
        sx={{
          width: 20,
          height: 20,
          border: '1px solid #ccc',
          borderRadius: '4px',
          color: value === min ? '#ccc' : '#333',
          backgroundColor: 'white',
          '&:disabled': { 
            color: '#ccc', 
            borderColor: '#eee',
            backgroundColor: '#f9f9f9'
          },
          '&:hover:not(:disabled)': { 
            backgroundColor: '#f5f5f5',
            borderColor: '#ccc'
          }
        }}
      >
        <Remove sx={{ fontSize: '16px' }} />
      </IconButton>
      <Typography sx={{ 
        minWidth: 32, 
        textAlign: 'center', 
        fontWeight: 500,
        fontSize: '15px',
        color: '#333',
        fontFamily: 'inherit'
      }}>
        {value}
      </Typography>
      <IconButton
        size="small"
        onClick={() => setValue(Math.min(max, value + 1))}
        disabled={value === max}
        sx={{
          width: 20,
          height: 20,
          border: '1px solid #ccc',
          borderRadius: '4px',
          color: value === max ? '#ccc' : '#333',
          backgroundColor: 'white',
          '&:disabled': { 
            color: '#ccc', 
            borderColor: '#eee',
            backgroundColor: '#f9f9f9'
          },
          '&:hover:not(:disabled)': { 
            backgroundColor: '#f5f5f5',
            borderColor: '#ccc'
          }
        }}
      >
        <Add sx={{ fontSize: '16px' }} />
      </IconButton>
    </Box>
  </Box>
);

export default PassengerCounter; 